import type { Ref } from 'vue'
import { defu } from 'defu'

export function useScrollToElement<T extends HTMLElement>(
  element: Ref<T | null>,
  defaultOptions?: Partial<ScrollIntoViewOptions>
) {
  const scrollOptions = defu(defaultOptions, {
    behavior: getAnimationBehaviour(),
    block: 'center'
  } satisfies ScrollIntoViewOptions)

  const scrollToElement = () => {
    if (element.value) {
      element.value.scrollIntoView(scrollOptions)
    }
  }

  const scrollToElementWithOffset = (offset: number) => {
    if (element.value) {
      const scrollOptions = defu(defaultOptions, {
        behavior: getAnimationBehaviour(),
        top:
          element.value.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset
      })

      window.scrollTo(scrollOptions)
    }
  }

  return {
    scrollToElement,
    scrollToElementWithOffset
  }
}
